import { useEffect } from 'react'

export default function useNetworkCanvas(canvasRef) {
  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    let animId
    let mouse = { x: -9999, y: -9999 }

    const resize = () => {
      canvas.width = canvas.offsetWidth
      canvas.height = canvas.offsetHeight
    }
    resize()
    window.addEventListener('resize', resize)

    const count = Math.min(
      70,
      Math.floor((canvas.width * canvas.height) / 18000)
    )
    const nodes = Array.from({ length: count }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 0.4,
      vy: (Math.random() - 0.5) * 0.4,
      r: Math.random() * 2 + 0.8,
      o: Math.random() * 0.4 + 0.15,
    }))

    const onMove = (e) => {
      const r = canvas.getBoundingClientRect()
      mouse.x = e.clientX - r.left
      mouse.y = e.clientY - r.top
    }
    const onLeave = () => {
      mouse.x = -9999
      mouse.y = -9999
    }
    canvas.addEventListener('mousemove', onMove)
    canvas.addEventListener('mouseleave', onLeave)

    const maxD = 140
    const mouseD = 200

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      for (const n of nodes) {
        n.x += n.vx
        n.y += n.vy
        if (n.x < 0 || n.x > canvas.width) n.vx *= -1
        if (n.y < 0 || n.y > canvas.height) n.vy *= -1

        const dm = Math.hypot(mouse.x - n.x, mouse.y - n.y)
        let op = n.o
        let rad = n.r
        if (dm < mouseD) {
          op = Math.min(1, op + (1 - dm / mouseD) * 0.5)
          rad += (1 - dm / mouseD) * 2.5
        }

        ctx.beginPath()
        ctx.arc(n.x, n.y, rad, 0, Math.PI * 2)
        ctx.fillStyle = `rgba(0,180,216,${op})`
        ctx.fill()
      }

      for (let i = 0; i < nodes.length; i++) {
        for (let j = i + 1; j < nodes.length; j++) {
          const d = Math.hypot(nodes[i].x - nodes[j].x, nodes[i].y - nodes[j].y)
          if (d < maxD) {
            ctx.beginPath()
            ctx.moveTo(nodes[i].x, nodes[i].y)
            ctx.lineTo(nodes[j].x, nodes[j].y)
            ctx.strokeStyle = `rgba(0,180,216,${(1 - d / maxD) * 0.12})`
            ctx.lineWidth = 0.5
            ctx.stroke()
          }
        }

        const dm = Math.hypot(mouse.x - nodes[i].x, mouse.y - nodes[i].y)
        if (dm < mouseD) {
          ctx.beginPath()
          ctx.moveTo(nodes[i].x, nodes[i].y)
          ctx.lineTo(mouse.x, mouse.y)
          ctx.strokeStyle = `rgba(72,202,228,${(1 - dm / mouseD) * 0.25})`
          ctx.lineWidth = 0.7
          ctx.stroke()
        }
      }

      animId = requestAnimationFrame(draw)
    }
    draw()

    return () => {
      cancelAnimationFrame(animId)
      window.removeEventListener('resize', resize)
      canvas.removeEventListener('mousemove', onMove)
      canvas.removeEventListener('mouseleave', onLeave)
    }
  }, [canvasRef])
}